import React from 'react';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import useSponsorMenu from 'hooks/useSponsorMenu';
import { useParams, Link } from 'react-router-dom';
import { deskTopMenuOnly } from 'components/app/views/apps/sponsorHome/constant';

const SponsorDropdownMenu = () => {
    useSponsorMenu();
    const { companyId, projectId } = useParams();
    const { activeMenu } = useSelector((state) => state?.sponsorMenu) || {};

    if (!activeMenu?.sublinks && activeMenu?.link !== 'sponsor-home')
        return (
            <h2 className="tw-block md:tw-hidden tw-font-semibold tw-mb-3 tw-text-[22px] tw-text-mobileTextBlack">
                {activeMenu?.name}
            </h2>
        );

    if (isEmpty(activeMenu) || activeMenu?.activeMenuKey === '') return '';

    const items = activeMenu?.sublinks?.map((link) => ({
        key: link.link,
        label: link.name,
    }));

    const menu = (
        <Menu
            selectable
            defaultSelectedKeys={[activeMenu?.activeMenuKey]}
            className="customDropdown"
        >
            {items.map((link) =>
                link.label === activeMenu?.activeMenuKey ||
                deskTopMenuOnly.includes(link?.key) ? (
                    <Menu.Item disabled key={link.label}>
                        <span className="tw-text-[#101828] tw-opacity-50 tw-text-base tw-font-normal">
                            {link.label}
                        </span>
                    </Menu.Item>
                ) : (
                    <Menu.Item key={link.label}>
                        <Link
                            className="tw-flex tw-gap-1 tw-items-center tw-flex-1"
                            to={`/company/${companyId}/project/${projectId}/${link?.key}?sponsor=1`}
                        >
                            <span className="tw-text-[#101828] tw-text-base tw-font-normal">
                                {link.label}
                            </span>
                        </Link>
                    </Menu.Item>
                )
            )}
            <style>{`
            .customDropdown .ant-dropdown-menu-item-selected, .ant-dropdown-menu-submenu-title-selected, .ant-dropdown-menu-item-selected > a, .ant-dropdown-menu-submenu-title-selected > a{
            background-color: white !important;
            }
            .customDropdown .ant-dropdown-menu {
            border-radius: 8px !important;
            }
            `}</style>
        </Menu>
    );

    return (
        <Dropdown
            trigger={['click']}
            overlay={menu}
            className="tw-block md:tw-hidden exhibitor_Dropdown"
        >
            <h2 className="tw-flex tw-flex-row tw-gap-2 tw-items-center tw-text-[22px] tw-capitalize tw-text-mobileTextBlack tw-font-semibold tw-mb-1">
                {activeMenu?.activeMenuKey}
                <DownOutlined />
            </h2>
        </Dropdown>
    );
};

export default SponsorDropdownMenu;
